import { FC, useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import parse from 'html-react-parser'
import { GetLoginError } from '../../data/loginService'
import { LoginError } from '../../data/interfaces/loginRequest'
import {
    ModalTitleBar,
    ModalTitleContent,
    ModalErrorMessage,
    ErrorIcon,
    ModalBody,
    ModalIconSpace,
    ModalButton,
    ModalTitleClose,
    ModalTitleCloseIcon
} from "../Styles";
import error from '../../assets/images/alert.png'
import unknown from '../../assets/images/unknown.png'
import warning from '../../assets/images/warning.png'
import Notification from '../../assets/images/small E Logo.png'
import { faXmark } from "@fortawesome/free-solid-svg-icons";

interface myProps {
    handleClose: (result: boolean) => void,
    alertId: number,
    isOpen: boolean,
    MultiOption: boolean,
    onAlertIdChange: any,
}

const AlertColor: { [key: string]: any } = {};
AlertColor["Warning"] = { color: "#ffce62", img: warning }
AlertColor["Error"] = { color: "#e74741", img: error }
AlertColor["Unknown"] = { color: "#656a69", img: unknown }
AlertColor["Notification"] = { color: "#c1cd23", img: Notification }

const ModalType: {
    [key: number]: LoginError
} = {};

ModalType[1] = {
    Message: parse(`<b>Internal Error</b>`),
    Type: "Unknown",
    DisplayID: 1
}

const AlertDialog: FC<myProps> = ({ handleClose, alertId, isOpen, MultiOption}: myProps) => {

    
    const [loginError, setLoginError] = useState<LoginError>(ModalType[1]);
    //const [multiOption, SetMultiOption] = useState(false);
    const [isOpenState, setisOpenState] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            if (alertId > 1) {
                try {
                    const errorInfo = await GetLoginError(alertId);

                    if (errorInfo == null) {
                        //SetMultiOption(false)
                        setLoginError(ModalType[1])
                    }
                    else {
                        setLoginError({ Message: parse(errorInfo.message), Type: errorInfo.type, DisplayID: parseInt(errorInfo.displayId) })
                        if (errorInfo.type !== "Unknown") {
                            //SetMultiOption(MultiOption)
                        }

                    }
                } catch (error) {
                    console.error(error);
                    //SetMultiOption(false)
                    setLoginError(ModalType[1])
                }
                setisOpenState(isOpen)
            }
        };
        fetchData();
    }, [alertId, MultiOption, isOpen]);


    return (
        <div>
            <Dialog
                BackdropProps={{ style: { backgroundColor: "#676767", opacity: .85 } }}
                open={isOpenState}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: ".5rem", maxHeight: "450px", width: '400px', margin:"0px"
                    }
                }}
            >
                <ModalTitleBar id="alert-dialog-title" style={{ backgroundColor: AlertColor[loginError.Type].color }}>
                    <ModalTitleContent><b>{loginError.Type}</b></ModalTitleContent>
                    {!MultiOption && (<ModalTitleClose>
                        <ModalTitleCloseIcon icon={faXmark} size="xl" onClick={() => handleClose(false)} />
                    </ModalTitleClose>)}
                </ModalTitleBar>
                <DialogContent style={{ paddingTop: "20px", paddingBottom: "0px" }}>

                    <ModalBody id="alert-dialog-description">
                        <ModalIconSpace>
                            <ErrorIcon>
                                <img style={{objectFit:"contain"}} alt= {loginError.Type} src={AlertColor[loginError.Type].img}></img>
                            </ErrorIcon>
                        </ModalIconSpace>


                        <ModalErrorMessage><span>{loginError.Message}</span></ModalErrorMessage>

                    </ModalBody>
                </DialogContent>
                <DialogActions style={{ paddingRight: "25px", paddingBottom: "15px", gap: "8px", maxHeight: MultiOption ? "45px" : "0px"}}>
                    {MultiOption && (<>
                        <ModalButton
                            customcolor='red'
                            variant='contained'
                            size='small'
                            type="submit"
                            onClick={() => handleClose(false)}
                        >
                            No
                        </ModalButton>
                        <ModalButton
                            customcolor='black'
                            variant='contained'
                            size='small'
                            type="submit"
                            onClick={() => handleClose(true)}
                        >
                            Yes
                        </ModalButton>

                    </>

                    )}
                </DialogActions>
            </Dialog>
        </div>
    );
}
export default AlertDialog